import { render } from "./LivingComment.vue?vue&type=template&id=ff1f52c0&scoped=true"
import script from "./LivingComment.vue?vue&type=script&lang=js"
export * from "./LivingComment.vue?vue&type=script&lang=js"

import "./LivingComment.vue?vue&type=style&index=0&id=ff1f52c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ff1f52c0"

export default script